import { view } from "./AuthView";

export const Auth = () => {
  return view({});
};
